import api from "./axiosInstance";
import networkConfig from "../utils/networkConfig";

export const getAds = async () => {
  const res = await api.get(networkConfig.ads.getAds);
  return res.data;
};

export const createAds = async (data) => {
  const res = await api.post(networkConfig.ads.createAds, data);
  return res.data;
};

export const deleteAds = async (id) => {
  const res = await api.delete(`${networkConfig.ads.deleteAds}/${id}`);
};
